import cn from "classnames";

// Styles
import s from "./Button.module.scss";
import { Link } from "@/shared/components/app/Link";

export type ButtonVariant = "accent" | "primary" | "link" | "default";

export type ButtonProps = {
  variant?: ButtonVariant;
  outlined?: boolean;
  size?: "xs" | "tiny" | "default" | "small" | "thin" | "fullwidth";
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  href?: string;
  blank?: boolean;
  onClick?: (event: React.MouseEvent) => void;
  htmlType?: "button" | "submit" | "reset";
};

/**
 * TODO: Cover case with default button
 */
export const Button = ({
  variant = "accent",
  size = "default",
  disabled,
  children,
  className,
  outlined,
  htmlType,
  ...props
}: ButtonProps) => {
  const isLink = "href" in props;
  const classNames = cn(
    s.button,
    "button",
    s[variant],
    s[`size-${size}`],
    { [s.disabled]: disabled, [s.outlined]: outlined },
    className
  );
  const linkProps = isLink && props.blank ? { target: "_blank", rel: "noopener" } : {};

  return isLink ? (
    <Link className={classNames} href={props.href || "#"} {...linkProps}>
      {children}
    </Link>
  ) : (
    <button className={classNames} disabled={disabled} type={htmlType || "button"} {...props}>
      {children}
    </button>
  );
};
